var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPatentLogoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F5F8FD",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3062D4",
    fillRule: "evenodd",
    d: "M23.6 10.4h-8.4a3.6 3.6 0 0 0-3.6 3.6v12a3.6 3.6 0 0 0 3.6 3.6h3.745c.379 0 .624-.409.488-.763a6.5 6.5 0 0 1 7.129-8.75c.325.053.638-.186.638-.516V14a3.6 3.6 0 0 0-3.6-3.6ZM15 13a1 1 0 1 0 0 2h8.5a1 1 0 1 0 0-2H15Zm-1 5a1 1 0 0 1 1-1h6.5a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3062D4",
    d: "M26.753 22.78a1 1 0 0 0-2 0v2.394h-2.395a1 1 0 0 0 0 2h2.395v2.394a1 1 0 1 0 2 0v-2.394h2.394a1 1 0 0 0 0-2h-2.394v-2.395Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPatentLogoBg);
export default __webpack_public_path__ + "static/media/add-patent-logo-bg.5e4c60d1e4cb9b8ee17796d5a34426b5.svg";
export { ForwardRef as ReactComponent };